import {Button, Card, DatePicker, Form, Icon, Input, message, Popconfirm, Radio, Select, Spin,} from 'antd';
import React from 'react';
import {isArray, sanitizeFieldName} from '../../util/methods';
import moment from 'moment';
import MasterModal from "../../components/MasterModal";

class Create extends React.Component {

  state = {
    showCancelButton: false,
    assetsPresent:[],
    keys: [],
    assetsAddedInLocation: {},
    radioButtonValue: 'name',
  };

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    const {data: {assets = [{}]}} = this.props;
    this.setState({
      keys: assets,
    });
  }

  addAsset = () => {
    const {keys} = this.state;
    keys.push(`${'assets'}${this.id++}`);
    this.setState({
      keys: keys,
    });
  };

  removeAsset = (index, boxIndex) => {
    const {keys, assetsPresent} = this.state;
    const { form, filters } = this.props;
    const item = filters['assets'];
    if (keys.length === 1) {
      return;
    }
    const val = form.getFieldValue('assets');
    val.splice(boxIndex, 1);
    keys.splice(boxIndex, 1);
    assetsPresent.splice(boxIndex, 1);
    for (let i = 0; i< val.length; i++) {
      Object.keys(item.schema).map((itm) => {
        form.setFieldsValue({
          [`assets[${i}]['${itm}']`]: val[i][itm],
        });
      });
    }
    this.setState({
      keys: keys,
      assetsPresent: assetsPresent,
    });
  };

  secondChange = (e) => {
    if(e.target.checked){
      this.setState({nameCheck: true});
      this.setState({idCheck: false});
    }
    if(!(e.target.checked)){
      this.setState({nameCheck: false});
      this.setState({idCheck: true});
    }
  }

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const data = Object.assign({}, values);

      if (match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  onSearchBoxChange = (e) => {
    this.setState({
      radioButtonValue: e.target.value
    })
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.data && nextProps.data.assets && JSON.stringify(nextProps.data.assets) !== JSON.stringify(this.props.data.assets)) {
      const newArr = [];
      nextProps.data.assets.map((item, idx) => {
        item.asset && newArr.push(item.asset._id);
      });
      this.setState({
        keys: nextProps.data.assets,
        assetsPresent: newArr,
      });
    }
  }

  handleAssetChange = () => {
    this.setState({showCancelButton: true});
  }

  showAssets = (index, e) => {
    const {assetsList} = this.props;
    const assets = [...this.state.assetsPresent];
    const selectedAsset = assetsList && assetsList['assets'].find((asset) => asset['asset']._id === e);
    assets[index] = selectedAsset;
    this.setState({assetsPresent: assets});
  };

  getEaiByEmployee = (e) => {
    this.props.fetchEaiByEmployee(e);
  };

  getAssetsByEai = (e) => {
    this.props.fetchAssetsByEai(e);
  };

  componentWillUnmount(): void {
  this.props.clearData();
  }

  cancelEai = (e) => {
    e.preventDefault();
    const data = this.props.form.getFieldsValue();
    console.log(data);
    this.props.cancelEai(data);

      //this.props.cancelEai({eai: this.props.form.getFieldValue('eai')});
      //this.props.cancelEai(data);
  };

  assetFormItems() {
    const {data, form, filters, assetsList, resource, title} = this.props;
    const {getFieldDecorator} = form;
    const {keys, assetsPresent} = this.state;
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
    };
    return keys && isArray(keys) && keys.map((k, index) => {

      return <div key={index} style={style}>
        <Form.Item key={`${index}0`} label={'Select Asset Code'}>
          {getFieldDecorator(`assets[${index}]['asset']`, {
            rules: [{required: true, message: `Asset is required!`}],
            initialValue: data.assets && data.assets[index] && data.assets[index].asset && data.assets[index].asset._id || '',
          })(<Select
            showSearch
            mode="single"
            disabled={title === 'EDIT' || false}
            style={{width: '100%'}}
            placeholder="Please select asset"
            onSelect={this.showAssets.bind(this, index)}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {assetsList && assetsList.assets && assetsList.assets.length>0 ? assetsList.assets.map(item => {
              return <Select.Option key={item.asset._id} value={item.asset._id}>{item.asset.assetCode}</Select.Option>
            }) : data.assets && data.assets[index] ? <Select.Option
              value={data.assets[index] && data.assets[index].asset && data.assets[index].asset._id}>{data.assets && data.assets[index].asset && data.assets[index].asset.assetCode}</Select.Option> : ''}

          </Select>)}
        </Form.Item>

        <div style={{display:'flex', flexDirection:'row',width: '100%'}}>

          <Form.Item key={`${index}2receivedLocation`} label={'Received Location'} style={{width: '50%', marginRight:'3vh'}}>
            {getFieldDecorator(`assets[${index}]['receivedLocation']`, {
              rules: [{required: true, message: `Received Location is required!`}],
              initialValue: data.assets && data.assets[index] && data.assets[index].receivedLocation && data.assets[index].receivedLocation._id || '',
            })(
            <Select
              showSearch
              disabled={title === 'EDIT' || false}
              mode="single"
              placeholder={`Please Select Location`}
              filterOption={(input, option) =>
                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
              }
            >
              {filters['assets'] && filters['assets']['schema'] && filters['assets']['schema']['receivedLocation'].data.data.map(item =>
                <Select.Option key={item._id}
                               value={item._id}>{item.name}</Select.Option>)}
            </Select>)}
          </Form.Item>


          <Form.Item key={`${index}3receivedSubLocation`} label={'Received Sub Location'} style={{width: '50%'}}>
              {getFieldDecorator(`assets[${index}]['receivedSubLocation']`, {
              //rules: [{required: true, message: `Received Sub Location is required!`}],
              initialValue: data.assets && data.assets[index] && data.assets[index].receivedSubLocation && data.assets[index].receivedSubLocation._id || '',
              })(
            <Select
              showSearch
              mode="single"
              placeholder={`Please Select Sub Location`}
              disabled={title === 'EDIT' || false}
              filterOption={(input, option) =>
                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
              }
            >
              {filters['assets'] && filters['assets']['schema'] && filters['assets']['schema']['receivedSubLocation'].data.data.map(item =>
                <Select.Option key={item._id}
                               value={item._id}>{item.name}</Select.Option>)}
            </Select>)}
          </Form.Item>
        </div>

          {index > 0 ? (
            <Icon
              className="dynamic-delete-button"
              type="minus-circle-o"
              onClick={() => this.removeAsset(`${k}`, index)}
            />
          ) : null}
      </div>
    });
  }

  changeEmployee = (e) => {
    const {form} = this.props;
    form.setFieldsValue({
      [`assets[0]['asset']`]: '',
    });
    form.setFieldsValue({
      eai: '',
    });
    this.setState({keys: [{}], showCancelButton: false});
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, form } = this.props;
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            {
              title === 'EDIT' ? <Form.Item key={'eaiNo'} label={'Receipt Number'}>
                {getFieldDecorator('issueNo', {
                  rules: [{ required: false, message: `Receipt Number is required!` }],
                  initialValue: ((data && data.issueNo) || ''),
                })(<Input disabled/>)
                }
              </Form.Item> : ''
            }
            {(filters['receiptStatus'] && title === 'CREATE') ? null :
              <Form.Item key={'receiptStatus'} label={'Receipt Status'}>
                {getFieldDecorator('receiptStatus', {
                  initialValue: data && data.receiptStatus,
                })(<Input disabled/>)
                }
              </Form.Item>
            }
              <Form.Item key={'receiptDate'} label={'Receipt Date'}>
                {getFieldDecorator('receiptDate', {
                  rules: [{required: true, message: `Receipt Date is required!`}],
                  initialValue: data && data.receiptDate && moment(data.receiptDate),
                })(<DatePicker
                  disabled={(title === 'EDIT' && filters['receiptDate'] && filters['receiptDate'].options.disabledOnEdit) || false}/>)
                }
              </Form.Item>
              <React.Fragment key={'employeebox'}>
                <Form.Item key={'checkbox'}>
                  <label style={{marginRight: '10px'}}>Search By: </label>
                  <Radio.Group key={'radiobox'} onChange={this.onSearchBoxChange} value={this.state.radioButtonValue}>
                    <Radio value={'name'}>Employee Name</Radio>
                    <Radio value={'id'}>Employee Id</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item key={'employee'} label={'Employee'}>
                  {getFieldDecorator('employee', {
                    rules: [{required: true, message: `Employee is required!`}],
                    initialValue: data && data.employee && data.employee._id,
                  })(<Select
                    showSearch
                    style={{width: '80%'}}
                    placeholder="Select Employee"
                    onSelect={this.getEaiByEmployee.bind(this)}
                    onChange={this.changeEmployee}
                    disabled={title === 'EDIT'}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    >
                    {filters['employee'] && filters['employee']['data'] && filters['employee']['data']['data'].map(item =>
                      <Select.Option key={item._id} value={item._id}>{this.state.radioButtonValue === 'name' ? item.name : item.employeeCode}</Select.Option>)}
                  </Select>)}
                  {
                    filters['employee'] && filters['employee'].options && filters['employee'].options.master ?
                      <MasterModal resource={resource} item={filters['employee'].options.ref} title={'CREATE'}/> : ''
                  }
                </Form.Item>
              </React.Fragment>
                <Form.Item key={'eai'} label={'EAI'}>
                  {getFieldDecorator('eai', {
                    rules: [{required: true, message: `EAI is required!`}],
                    initialValue: data && data.eai && data.eai.issueNumber,
                  })(<Select
                    showSearch
                    style={{width: '80%'}}
                    placeholder="Select Eai"
                    onSelect={this.getAssetsByEai.bind(this)}
                    onChange={this.handleAssetChange}
                    disabled={title === 'EDIT'}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.props.eaiList && this.props.eaiList.map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.issueNumber}</Select.Option>)}
                  </Select>)}
                </Form.Item>
                    {
                      title === 'CREATE' && this.state.showCancelButton && <div style={{paddingBottom: '12px'}}>
                        <Popconfirm
                          title="Are you sure you want to cancel this record?"
                          onConfirm={this.cancelEai}
                          onCancel={() => {message.error('Cancelled')}}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button type="primary" className="gx-mb-0" htmlType={'button'} loading={loading}>CANCEL EAI</Button>
                        </Popconfirm>

                      </div>
                    }
              <div>Assets</div>
              {this.assetFormItems()}
              <Button type="dashed" onClick={this.addAsset} style={{width: '60%', marginTop: '15px'}}>
                <Icon type="plus"/> Add Asset
              </Button>

              <Form.Item key={'receivedBy'} label = {'Received By'}>
                {getFieldDecorator('receivedBy', {
                  rules: [{required: true, message: `Received By Field is required!`}],
                  initialValue: data && data.receivedBy && data.receivedBy._id,
                  })(<Select
                    showSearch
                    style={{width: '80%'}}
                    placeholder="Received By"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    disabled={(title === 'EDIT' && filters['receivedBy'] && filters['receivedBy'].options.disabledOnEdit) || false}
                  >
                    {filters['receivedBy'] && filters['receivedBy']['data'] && filters['receivedBy']['data']['data'].map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                {
                  filters['receivedBy'] && filters['receivedBy'].options && filters['receivedBy'].options.master ?
                    <MasterModal resource={resource} item={filters['receivedBy'].options.ref} title={'CREATE'}/> : ''
                }
                </Form.Item>

                <Form.Item key={'receivedDate'} label={'Received Date'}>
                  {getFieldDecorator('receivedDate', {
                    rules: [{required: true, message: `Received Date is required!`}],
                    initialValue: data && data.receivedDate && moment(data.receivedDate),
                  })(<DatePicker
                    disabled={(title === 'EDIT' && filters['receivedDate'] && filters['receivedDate'].options.disabledOnEdit) || false}/>)
                  }
                </Form.Item>


              <Form.Item>
                {
                  title === 'CREATE' ? <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading} disabled={title === 'EDIT'}>
                    {title === 'EDIT' ? 'UPDATE' : 'CREATE'}
                  </Button> : ''
                }
              </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
